export default __webpack_public_path__ + "static/fav-img03-2f45f6878f053d0893149e2d53917c66.jpg";